import { tokens } from '@cellula/react-theme-patient';
import { Outlet } from 'react-router';
import styled from 'styled-components';

const StyledWebsiteMain = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 1240px;
	margin: 0 auto;
	width: 100%;
	padding: ${tokens.spacing.x3} ${tokens.spacing.x2};

	${tokens.breakpointQuery.medium} {
		padding: ${tokens.spacing.x4} ${tokens.spacing.x4};
	}
`;

export function LayoutOutletMain() {
	return (
		<StyledWebsiteMain>
			<Outlet />
		</StyledWebsiteMain>
	);
}
